import { getNotDeliveredReasonListState } from './not-delivered-reason.selectors'
import ListTrait from 'src/app/traits/list.trait'
import {
  SetDefaultData,
  UpdateField,
  FetchNotDeliveredReasonListRequest,
  DeleteNotDeliveredReasonRequest,
} from './not-delivered-reason.actions'
import { Router, ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import { Map } from 'immutable'
import { Subscription } from 'rxjs'

@Component({
  selector: 'app-not-delivered-reason',
  templateUrl: './not-delivered-reason.component.html',
  styleUrls: ['./not-delivered-reason.component.css'],
})
export class NotDeliveredReasonComponent
  extends ListTrait
  implements OnInit, OnDestroy
{
  private shouldReload: boolean = false
  public isLoading: boolean = false
  private state$: Subscription
  private route$: Subscription
  public columns: object[] = [
    {
      prop: 'text',
      name: 'TEXT',
      sortable: true,
    },
    {
      width: '162px',
      name: '',
      template: 'actionsColumn',
    },
  ]

  constructor(
    private store: Store<any>,
    public router: Router,
    private route: ActivatedRoute,
  ) {
    super(router)
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('list'))
    this.state$ = this.store
      .pipe(select(getNotDeliveredReasonListState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
        if (
          state.get('shouldReload') != this.shouldReload &&
          state.get('shouldReload')
        ) {
          this.runFilter()
        }
        this.shouldReload = state.get('shouldReload')
      })

    this.route$ = this.route.queryParams.subscribe(this.runFilter.bind(this))
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.route$.unsubscribe()
  }

  runFilter(queryParams: any = {}) {
    const { page, page_size } = this.state.get('queryParams').toJS()
    const params = { page, page_size, ...queryParams }

    this.store.dispatch<any>(
      new FetchNotDeliveredReasonListRequest({
        filters: params.keyword
          ? {
              or: [{ field: 'text', value: params.keyword }],
            }
          : {},
        pageSize: parseInt(params.page_size),
        page: parseInt(params.page) - 1,
        sort: {
          order: params.sort?.toUpperCase(),
          prop: params.order_by,
        },
      }),
    )

    this.store.dispatch(new UpdateField('queryParams', params, 'list'))
  }

  deleteContactType(id: number) {
    this.store.dispatch(new DeleteNotDeliveredReasonRequest(id))
  }
}
